import React from "react";
import {Card} from "flowbite-react";
import StartBot from "./StartBot";
import Code from "../Code";

const Setup = () => {
    let formyTemplate = process.env.REACT_APP_FORMY_LINK_TEMPLATE;
    const setupForm = `<form action="${formyTemplate}" method="post">`;
    const setupInput = `<input type="text" name="name" required>`;

    return (
        <section className="bg-white dark:bg-gray-700">
            <div className="py-8 px-4 mx-auto max-w-screen-lg">
                <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
                    <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                        Get Started in Minutes
                    </h2>
                    <p className="font-light sm:text-xl text-gray-900 dark:text-white">
                        A simple, fast, and free setup process
                    </p>
                </div>
                <div className="text-gray-500 sm:text-lg dark:text-gray-300">
                    <h3 className="mb-4 text-2xl tracking-tight font-bold text-gray-900 dark:text-white">
                        1. Start the Bot
                    </h3>
                    <div className="mb-4 font-light">
                        <div className="mb-4"> Launch the bot and receive your unique <b>FORM_TOKEN</b>. </div>
                        <Card id="verify-card">
                            <StartBot/>
                        </Card>
                        <div className="mt-4 text-blue-600 dark:text-blue-400">
                            <a href="/documentation" className="underline"> View Documentation </a>
                        </div>
                    </div>
                    <h3 className="mb-4 text-2xl tracking-tight font-bold text-gray-900 dark:text-white">
                        2. Connect Your Form
                    </h3>
                    <div className="mb-4 font-light">
                        <div className="mb-4"> Insert <b>FORM_TOKEN</b> into the form action URL and send data via POST. </div>
                        <Card className="max-w-screen-lg break-words">
                            <Code code={setupForm} language="html" />
                        </Card>
                    </div>
                    <h3 className="mb-4 text-2xl tracking-tight font-bold text-gray-900 dark:text-white">
                        3. Add Your Inputs
                    </h3>
                    <div className="mb-4 font-light">
                        <div className="mb-4"> Include all necessary input fields and make sure to specify the <b><u>name</u></b> attribute. </div>
                        <Card className="max-w-screen-lg">
                            <Code code={setupInput} language="html" />
                        </Card>
                        <div className="mt-4 text-blue-600 dark:text-blue-400">
                            <a href="#prebuilt-forms" className="underline"> Our Pre-built forms </a>
                        </div>
                    </div>
                    <h3 className="mb-4 text-2xl tracking-tight font-bold text-gray-900 dark:text-white">
                        4. Submit 🚀
                    </h3>
                    <p className="mb-4 font-light">
                        Once submitted, your form data will be instantly delivered to your Telegram.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Setup;